module.exports = __webpack_public_path__ + "img/one-two.55522b67.png";